module.exports = __webpack_public_path__ + "img/BS17.7755a25e.svg";